import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
} from 'react';

interface RedirectUrlContextProps {
  redirectUrl: string;
  setUrl: (url: string) => void;
}

const RedirectUrlContext = createContext<RedirectUrlContextProps | undefined>(
  undefined
);

interface RedirectUrlProviderProps {
  children: ReactNode;
}

export const RedirectUrlProvider = ({children}: RedirectUrlProviderProps) => {
  const [redirectUrl, setRedirectUrl] = useState(() => {
    // Retrieve the redirect URL from local storage, or use an empty string if it doesn't exist
    return localStorage.getItem('redirectUrl') || '';
  });

  const setUrl = (url: string) => {
    setRedirectUrl(url);
  };

  useEffect(() => {
    // Store the redirect URL in local storage whenever it changes
    localStorage.setItem('redirectUrl', redirectUrl);
  }, [redirectUrl]);

  const contextValue: RedirectUrlContextProps = {
    redirectUrl,
    setUrl,
  };

  return (
    <RedirectUrlContext.Provider value={contextValue}>
      {children}
    </RedirectUrlContext.Provider>
  );
};

export const useRedirectUrl = (): RedirectUrlContextProps => {
  const context = useContext(RedirectUrlContext);

  if (!context) {
    throw new Error('useRedirectUrl must be used within a RedirectUrlProvider');
  }

  return context;
};
